<template>
    <div>
        <top-navbar></top-navbar>
<div>
 

<div class="mb-5 background_color">
  <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/"> Home </router-link><span class="pfimg3 "><i class="fa fa-angle-right" aria-hidden="true"></i></span>Customer<span class="pfimg3 "><i class="fa fa-angle-right" aria-hidden="true"></i></span>Issue Tracking<span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> <router-link class="decoration" to="/issuetracking/index">Manage Issue </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Create Issue Tracking  </h6>
    <div style=" padding-bottom: 300px;" class="container-fluid">
<div class="card bdr-rad2 mt-1 shadow p-2 ">
<div class="card-body">
  <form @submit.prevent="SaveIssue()" >

<div class="row">


  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">First name</label>
            <input   v-model="issue.first_name" class="form-control" >

         
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Surename</label>
            <input   v-model="issue.surname" class="form-control" >

         
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Email Adress</label>
            <input   v-model="issue.email" class="form-control" >

         
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Mobile Number</label>
            <input   v-model="issue.mobile" class="form-control" >

         
    </div>
  </div>
 
</div>

<div class="row">

  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label font-size_def" style="font-size: small;">Description </label>
            <textarea  v-model="issue.description" class="form-control" rows="3" required></textarea>
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label font-size_def" style="font-size: small;">Address </label>
            <textarea  v-model="issue.address" class="form-control" rows="3" required></textarea>
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label " style="font-size: small;">Feedback on the case </label>
            <v-select class="font-size_def" label="label" :options="feedback" v-model="issue.feedback"></v-select>
    </div>
  </div>
  




  </div>



  
   

    <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
      <button  type="submit" class="btn btn-sm  btn-outline-primary mb-1 font-size_def bdr-rad bdr-rad">Create</button>
    </div>
    </div>



</form>
</div>
</div>
</div>
</div>









</div>






        
        <content-footer></content-footer>
    </div>
</template>
<script>
 import axios from 'axios';
 import authService from '@/auth.service';
  import TopNavbar from './../../layout/TopNavbar.vue'
  import ContentFooter from './../../layout/ContentFooter.vue'
  import vSelect from 'vue-select'

  export default {
    data() {
      return {
        access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
      
        issue:{},
        aprts:[],
        mcustomers:[],
        contacts:[],
        repots:[],
        severitys:[],
        prioritys:[],
        issue_types:[],
        feedback:[
        { label: 'Feedback via e-mail', value: 'Email' },
        { label: 'Feedback via SMS', value: 'SMS' },
        ],
      


        
      }

    },
    mounted(){
 
  this.loadApt();
  
  
 
    },
methods : {

 

  async SaveIssue() {
    
    console.log(this.issue);
   
    try {
      const { data} = await  axios.post('/issuetracking/create',{userid:this.userid,issue:this.issue},{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.status = data.status;
       if(this.status == 200){
        this.$router.push('/issuetracking/index');
       }
      
    } catch (error) {
      console.log(error.response);
    }
  },

      
    



  
  async loadApt() {
    console.log(this.access_token);
    try {
      const { data} = await  axios.get('/issuetracking/laoadaprt',{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
  
       this.severitys = data.severity;
       this.prioritys = data.priority;
       this.issue_types = data.issue_type;
      
    } catch (error) {
      console.log(error.response);
    }



    try {
         const { data} = await  axios.get('/mcustomer/customerload',{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          this.mcustomers = data.customers;
           this.contacts = data.contacts;
          // this.mbrands = data.mbrands;
          // this.mproducts = data.mproducts;
         
       } catch (error) {
         console.log(error.response);
       }




  },


  async loadcontact() {
       
     
       try {
         const { data} = await  axios.post('/mcustomer/loadcontact',{idcustomer:this.issue.idcustomer},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          this.contacts = data.contacts;
          // this.sales = data.salespeoples;
          
         
       } catch (error) {
         console.log(error.response);
       }
     },


 





  
  async loadreopt1(id) {
    console.log(id);
    try {
      const { data} = await  axios.get('/issuetracking/laoadrepoted1?id='+id,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.repots = data.repot;
      
    } catch (error) {
      console.log(error.response);
    }
  },

  


},

    components :{
        ContentFooter,
        TopNavbar,
        'v-select': vSelect,
    },
  }

</script>
<style scoped>

</style>